module.exports = __webpack_public_path__ + "img/instagram-gray.61bb693d.png";